// import PropTypes from 'prop-types';
import s from './ImageGalleryBlock.module.scss';
import classNames from 'classnames';
import ImageBlock from '../ImageBlock';

const ImageGalleryBlock = ({
    title = '',
    images = [],
    alignRight,
    noAspectRatio,
    showTitleInToc = false,
}) => {
    const className = classNames(s.Root, {
        [s.ThreeImages]: images.length === 3,
        [s.TwoImages]: images.length === 2,
        [s.AlignRight]: alignRight,
    });

    return (
        <>
            {!!title && (
                <h2
                    data-hide-title-in-toc={!showTitleInToc}
                    className={s.Title}>
                    {title}
                </h2>
            )}
            <div className={className}>
                {images.map((image, index) => {
                    const cls = classNames(s.Image, {
                        [s.ImageNoCover]: noAspectRatio,
                        [s.ImageNoAspect]:
                            noAspectRatio ||
                            (images.length === 2 && index === 1 && alignRight),
                    });

                    return (
                        <ImageBlock
                            extraClassNames={cls}
                            src={image.src}
                            description={image.description}
                            noCover={noAspectRatio}
                            width={image.width}
                            height={image.height}
                            key={index}
                        />
                    );
                })}
            </div>
        </>
    );
};

ImageGalleryBlock.propTypes = {};

export default ImageGalleryBlock;
